// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAnalyticsDashboardAppGroupIdGetCampaignsForFilterResult = arrayOf(
  objectOf({
    name: string,
    id: string,
    status: string,
  })
);
